<template>
	<div class="exam-page-wrapper">
		<ProductContentExam :contentData="contentData" :productVariantID="parsedProductVariantId" />
	</div>
</template>

<script>
import ProductContentExam from '../ProductContentDashboard/Content/Exam.vue';

export default {
	name: "Exam",
	props: { productVariantData: Object, contentData: Object },
	components: { ProductContentExam },
	computed: {
		parsedProductVariantId() {
			return this.$route.params.id.split("-").at(-1).split("_")[1] || null;
		},
	},
};
</script>

<style scoped>
.exam-page-wrapper {
	max-width: 960px;
	margin: 24px auto;
	padding: 0 24px;
	width: 100%;
}
</style>
